import moment from 'moment';
import React from 'react';
import { EventItem } from '../../types/event.type';
import UserLinkButton from '../button/user-link.button';
import HorizontalBar from '../horizontalBar';
import CoverImage from '../images/cover.image';
import { HStack, VStack } from '../layouts/stack.layout';
import { IconTextGroup } from '../typography/v2/icon-text-group';
import { TextGroup } from '../typography/v2/text-group';
import { TagsContainer } from './tags.container';

type Props = {
  event: EventItem;
};

export default function EventInfoCardContainer({ event }: Props) {
  return (
    <VStack gap="base">
      {event.title && event.imageSrc && (
        <CoverImage alt={event.title} src={event.imageSrc} />
      )}
      {event.artist && (
        <UserLinkButton to={event.artist.username} user={event.artist} />
      )}
      {event.tags && <TagsContainer tags={event.tags} />}
      <VStack extensions="w-full" gap="sm">
        <HStack gap="md" justify="between">
          <IconTextGroup
            iconFirst
            icon="events"
            text={moment(event.date).format('ll')}
          />
          <IconTextGroup iconFirst icon="time" text={event.time} />
        </HStack>
        <HorizontalBar />
        <IconTextGroup
          iconFirst
          icon="location"
          text={` ${event.arena}, ${event.location}`}
        />
        <HorizontalBar />
        <TextGroup heading="Description" subheading={event.description} />
      </VStack>
    </VStack>
  );
}
